export default __webpack_public_path__ + "static/media/Maor-package-icon.586c71c6.png";